import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  Space,
  message,
  Radio
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import { FileDetail, CustomUploadNew } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const SubContractModal = forwardRef(({contractId, projectId, id, submitInitFn,}, ref) => {
    const [form] = Form.useForm();
    const [type, setType] = useState('add');
    const [statusId, setStatusId] = useState(null);
    const [modalName, setModalName] = useState('Change Order');
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [filePaths, setFilePaths] = useState([]);
    const [detail, setDetail] = useState(null);
    const customUploadNewRef = useRef(null);
    
    useImperativeHandle(ref, () => ({
      openModal: (type, modalName, statusId) => {
        setType(type)
        setModalName(modalName)
        if(statusId){
          setStatusId(statusId)
        }
        setModalFlag(true)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        if(type !== 'add'){
          setRefuseReasonFlag(false)
          getDetailFn()
        }
      }else{
        setStatusId(null)
        setDetail(null)
        form.resetFields();
        setBtnLoading(false)
        setBtnDisabled(false)
      }
    }

    const getDetailFn = async() => {
      setBtnDisabled(true)
      const response = await http.get(api.getSubDetail, { params: {id: statusId || id} });
      if (response.code === "1") {
        setDetail(response.data)
        form.setFieldsValue({
          ...response.data,
          approvalType: type === 'approve' ? undefined : response.data.approvalType
        });
        if(['approve', 'edit'].includes(type) && customUploadNewRef.current){
          const list = (response.data?.fileList || [])?.map(item => ({ ...item, url: item.allPath, baseUrl: item.allPath, name: item.name || item.fileName, type: item.contentType}))
          customUploadNewRef.current.initUpdateList(list)
        }
        setRefuseReasonFlag(response.data.approvalType === 2)
      }
      setBtnDisabled(false)
    }

    const testFn = async () => {
      const formData = form.getFieldsValue();
      console.log("====formData", formData);
    }

    const [refuseReasonFlag, setRefuseReasonFlag] = useState(false);

    const approvalTypeChangeFn = (e) => {
      if (e.target.value === 1) {
        form.setFieldValue('refuseReason', '')
        setRefuseReasonFlag(false)
      }else{
        setRefuseReasonFlag(true)
      }
    }

    const submitAddFn = async() => {
      setBtnLoading(true)
      const response = await http.post(api.saveContractSub, {
        sub: {
          ...form.getFieldValue(),
          subType: 1,
          contractId,
          projectId
        },
        fileList: filePaths
      });
      if (response.code === "1") {
        message.success("New successfully");
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitApproveFn = async() => {
      setBtnLoading(true)
      const {approvalType, refuseReason} = form.getFieldValue()
      const response = await http.post(api.approveContractSub, {
        ...form.getFieldValue(),
        id,
        approvalType,
        refuseReason,
        fileList: filePaths.filter(item => !item.id)
      });
      if (response.code === "1") {
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitEditFn = async() => {
      setBtnLoading(true)
      const response = await http.post(api.updateSubContract, {
        ...form.getFieldValue(),
        id,
        fileList: filePaths.filter(item => !item.id)
      });
      if (response.code === "1") {
        message.success("Updated successfully");
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitFn = async() => {
      form.validateFields().then(value => {
        if(type === 'add'){
          submitAddFn()
        }else if(type === 'approve'){
          submitApproveFn()
        }else if(type === 'edit'){
          submitEditFn()
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }

    const deleteOldFn = async(file) => {
      let flag = false
      const response = await http.get(api.delContractFile, { params: {id: file.id} });
      if (response.code === "1") {
        flag = true
      }
      return flag
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="80%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Change Order
            </div>

            <Form.Item
              name="subName"
              label="Change Order Name"
              rules={[{ required: true, message: 'Change Order Name is required!' }]}
            >
              <Input 
                disabled={['view'].includes(type)}
                placeholder="Please input Change Order Name"
              />
            </Form.Item>

            {/* <Form.Item
              name="subType"
              label="Sub Type"
              rules={[{ required: true, message: 'Sub Type is required!' }]}
            >
              <Select
                disabled={['view'].includes(type) || detail?.subType === 2}
                placeholder="Select a type"
                options={
                  detail?.subType === 2 ? [
                    {
                      value: 2,
                      label: "Vendor Change Order",
                    },
                  ]:
                  [
                    {
                      value: 1,
                      label: "Change Order",
                    },
                    {
                      value: 3,
                      label: "Material",
                    }
                ]}
              />
            </Form.Item> */}

            {commonFn.formInputNumberDoc({
              form,
              label: "Change Order Amount",
              disabled: ['view'].includes(type),
              allowNegative: true
            })}

            <Form.Item
              name="writeNumber"
              label="Change Order #"
              rules={[{ required: true, message: 'Change Order # is required!' }]}
            >
              <Input                    
                disabled={['view'].includes(type)}
                placeholder="Please input Change Order #"
              />
            </Form.Item>

            <Form.Item
              name="remark"
              label="Remark"
            >
              <Input.TextArea
                disabled={['view'].includes(type)}
                placeholder="Please input Remark"
                autoSize={{ minRows: 3, maxRows: 10 }}
              />
            </Form.Item>

            {(type === 'approve' || (type === 'view' && detail?.approvalType !== 0)) && (
              <>
                <Form.Item
                  name="approvalType"
                  label="Select"
                  rules={[{ required: true, message: "Please select an option!" }]}
                  validateTrigger="onChange"
                >
                  <Radio.Group onChange={approvalTypeChangeFn} disabled={type === 'view' || btnDisabled}>
                    <Radio value={1}>Agree</Radio>
                    <Radio value={2}>Refuse</Radio>
                  </Radio.Group>
                </Form.Item>
                {refuseReasonFlag && (
                  <Form.Item
                    label="Refuse Reason"
                    name="refuseReason" // 必须添加 name 属性
                  >
                    <Input.TextArea
                      disabled={type === 'view'}
                      autoSize={{ minRows: 3, maxRows: 10 }}
                    />
                  </Form.Item>
                )}
              </>
            )}
          </Col>
          <Col span={16}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Upload Signed Change order
            </div>
            <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }} name="uploadFile" label={null}>
              {['add', 'approve', 'edit'].includes(type) ? (
                <CustomUploadNew
                  ref={customUploadNewRef}
                  customConfig={{
                    accept: ".jpg, .jpeg, .png, .pdf",
                    status: 'add',
                    deleteOldFn: deleteOldFn
                  }}
                  setFilePaths={setFilePaths} 
                  filePaths={filePaths} 
                  setBtnDisabled={setBtnDisabled}
                  btnDisabled={btnDisabled}
                />
              ) : (
                <FileDetail
                  urlKey="allPath"
                  fileList={detail?.fileList || []}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
            TEST
          </Button> */}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          {
            type !== 'view' && (
              <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled}>
                Submit
              </Button>
            ) || null
          }
        </Space>
      </div>
    </Modal>
  );
});

export default SubContractModal;